module.exports = __webpack_public_path__ + "static/img/gxjsqy.6adb452d.png";